import React from "react";

import ContactForm from "../../components/Contact/ContactForm";

export default function Contact() {
  return (
    <div>
      <main style={{ minHeight: '60vh', padding: '36px 24px' }}>
        <div className="contact-layout">
          <aside className="contact-coords">
            <h3 style={{ marginTop: 0, color: 'var(--text)' }}>Nos coordonnées</h3>
            <p style={{ margin: '8px 0', color: '#475569' }}><strong>Email :</strong> hassanesoumahoro6@gmail.com</p>
            <p style={{ margin: '8px 0', color: '#475569' }}><strong>Téléphone :</strong> 07 67 15 67 49</p>
          </aside>
          <div className="contact-main-form">
            <h1 style={{ color: '#4b004b', fontWeight: '700', fontSize: '2rem', marginBottom: 8 }}>Contact</h1>
            <p style={{ color: '#374151', fontSize: '1.05rem', marginBottom: 18 }}>Vous avez un projet, une question ou souhaitez collaborer ? Remplissez le formulaire, nous vous répondrons rapidement.</p>
            <ContactForm />
          </div>
        </div>
      </main>
    </div>
  );
}
